import { formatDuration } from "components/helpers/format";
import WorkBlock from "domain/WorkBlock";
import lodashEscape from "lodash/escape";

export default function teardownTimeMenuItem({
  onCustomTeardownTime,
  onScheduleTeardownTime,
  teardownTimes,
  workBlock,
}) {
  return {
    cls: "pendo-schedule-teardown-time-context-menu-item",
    menu: teardownTimeSubMenuItems({ onCustomTeardownTime, onScheduleTeardownTime, teardownTimes, workBlock }),
    name: "schedule-teardown-time",
    text: "Schedule teardown time",
  };
}

function teardownTimeSubMenuItems({ onCustomTeardownTime, onScheduleTeardownTime, teardownTimes, workBlock }) {
  return [
    ...existingTeardownTimes({ onScheduleTeardownTime, teardownTimes, workBlock }),
    customTeardownTimeItem({ onCustomTeardownTime, workBlock }),
  ];
}

function existingTeardownTimes({ onScheduleTeardownTime, teardownTimes, workBlock }) {
  return teardownTimes.map(({ label, duration }) => {
    const formattedDuration = formatDuration(duration);
    const menuText = `${label} (${formattedDuration})`;

    return {
      onItem: () => {
        const updatedBlock = WorkBlock.updateBlock(workBlock, {
          teardownTimeDuration: duration,
          teardownTimeLabel: label,
        });

        return onScheduleTeardownTime(updatedBlock);
      },
      text: lodashEscape(menuText),
    };
  });
}

function customTeardownTimeItem({ onCustomTeardownTime, workBlock }) {
  return {
    onItem: onCustomTeardownTime,
    text: workBlock.teardownTimeDuration === 0 ? "Custom teardown time" : "Edit teardown time",
  };
}
